import {Col, Row, Button, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import CardProfile from "../cards/cardProfile";
import CardAddress from "../cards/cardAddress";
import CardParticipant from "../cards/cardParticipant";
import CardCourse from "../cards/cardCourse";
import {Link, useNavigate} from "react-router-dom";
import LogoutButton from "../layout/logoutButton";
import ApiService from "../../services/ApiService";
import StorageManager from "../../services/StorageManager.service";
import AppRoute from "../../utils/AppRoute";
import GenericErrorModal from "../modal/genericErrorModal";

const Account = () => {

    const navigate = useNavigate();
    const [refresh, setRefresh] = useState(0);
    const [userInfo, setUserInfo] = useState();
    const [showDelete, setShowDelete] = useState();
    const [userDataInfo, setUserDataInfo] = useState();
    const [addressCard, setAddressCard] = useState([]);
    const [bookedCourses, setBookedCourses] = useState([]);
    const [participantList, setParticipantList] = useState([]);

    const [errorModal, setErrorModal] = useState({
        state: false,
        title: "",
        body: ""
    });

    useEffect(() => {
        getUserDataInfo();
        getUserOrder();
        getUserInfo();
        getListaPartecipanti();
    }, [refresh])
    const getListaPartecipanti = async () => {
        let listOfParticipant = []
        ApiService.getParticipantByUserId().then((partList) => {
            for (let i = 0; i < partList.participantDtoList.length; i++) {
                let currentParticipant = partList.participantDtoList[i]
                listOfParticipant.push(<CardParticipant key={i} participant={currentParticipant} refresh={setRefresh}
                                                        participantIndex={i + 1} setError={setErrorModal}/>)
            }

            setParticipantList(listOfParticipant);
        })
    }

    const getUserDataInfo = async () => {

        ApiService.getUserDataFromId().then((userData) => {

            if (userData.userDataDtoList.length > 0){
                let currentData = userData.userDataDtoList[0];

                setAddressCard(<Row className={'mb-4'}>
                    <Col xs={12}>
                        <p className={'fw-bold mb-1'}>Indirizzo</p>
                        <CardAddress key={0} userData={currentData}/>
                    </Col>
                </Row>);
                setUserDataInfo(userData.userDataDtoList)
            }
        })
    }

    const getUserInfo = async () => {
        ApiService.getUserInfoFromId().then((userData) => {
            setUserInfo(userData)
        })
    }

    const getUserOrder = async () => {
        let listOfCoruses = [];

        ApiService.getBookedCourseByUser().then(bookedCourses => {
            bookedCourses.bookCourseDtoList.forEach(bookedCourse => {
                listOfCoruses.push(<CardCourse key={bookedCourse.id} bookedCourses={bookedCourse}/>)
            })
            setBookedCourses(listOfCoruses)
        })
            .catch((error) => console.log(`ErrorState: ${error.status}, ErrorMessage: ${error.message}`))
    }

    const handleEliminaProfilo = (e) => {
        e.preventDefault();

        setShowDelete(true);
    }

    const handleEliminaProfiloConferma = (e) => {
        e.preventDefault();

        ApiService.deleteUserProfile(userInfo.id).then(response => {
            setErrorModal({
                state: true,
                title: "Eliminazione completa",
                body: "Continua"
            })
            StorageManager.clearUserInfo();
            navigate(AppRoute.BASE)
        })
            .catch(() => {
                setErrorModal({
                    state: true,
                    title: "Errore nell'eliminazione",
                    body: "Ok"
                })
            })
    }

    const handleClose = () => {
        setShowDelete(false)
    }

    const handleCloseErrorModal = () => setErrorModal({
        state: false,
        title: "",
        body: ""
    })

    return (
        <>
            <Row>
                <Col lg={6}>
                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Account</h2>
                        </Col>
                    </Row>

                    <Row className={'mb-4'}>
                        <Col xs={12}>
                            <p className={'fw-bold mb-1'}>Informazioni profilo</p>
                            {userInfo && <CardProfile userData={userInfo}/>}
                            <div className={'d-flex justify-content-end'}>
                                {userInfo &&
                                    <Link to={AppRoute.EDIT} state={{editMode: true, email: userInfo.email}}
                                          className={'btn btn-primary px-5 fw-bold'}>Modifica</Link>}
                            </div>
                        </Col>
                    </Row>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Indirizzi</h2>
                        </Col>
                    </Row>

                    <Row className={'mb-4'}>
                        <Col>
                            {addressCard.length > 0 ? "Nessun Indirizzo registrato" : addressCard}
                            {userDataInfo === undefined ?
                                <>
                                    <Col>
                                        Nessun indirizzo registrato
                                    </Col>
                                    <Col>
                                        <Link to={AppRoute.ADDRESS}>Aggiungi Indirizzo</Link>
                                    </Col>
                                </>
                                :
                                <div className={'d-flex justify-content-end'}>
                                    <Link to={AppRoute.ADDRESS} state={{
                                        editMode: true,
                                        email: userDataInfo.userDataDtoList,
                                        userId: userDataInfo.userId,
                                    }} className={'btn btn-primary px-5 fw-bold'}>Modifica</Link>
                                </div>
                            }

                        </Col>
                    </Row>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Lista partecipanti</h2>
                        </Col>
                    </Row>
                    <Row className={'mb-4'}>
                        <Col xs={12}>
                            {participantList.length > 0 ? participantList : "Nessun partecipante registrato"}
                        </Col>
                        <Col xs={12}>
                            <Link to={AppRoute.PARTICIPANT}>Aggiungi partecipante</Link>
                        </Col>
                    </Row>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>I tuoi corsi</h2>
                        </Col>
                    </Row>
                    <Row className={'mb-4'}>
                        <Col xs={12}>
                            {bookedCourses.length > 0 ? bookedCourses : "Nessun corso prenotato"}
                        </Col>
                    </Row>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <Button variant={'primary'} className={'px-5 fw-bold'}
                                    onClick={(e) => handleEliminaProfilo(e)}>Elimina profilo</Button>
                        </Col>
                    </Row>

                    <Modal show={showDelete} onHide={handleClose} backdrop='static' keyboard="False" size="lg" centered>
                        <Modal.Header className={'justify-content-end py-0'}>
                            <Button variant={'link'} onClick={handleClose}>
                                chiudi x
                            </Button>
                        </Modal.Header>
                        <Modal.Body className={'mt-4 mb-5'}>
                            <h2 className={'title fw-bold'}>Elimina Profilo</h2>
                            <p>Sei sicuro di voler eliminare il profilo?</p>
                            <Button variant={'primary'} className={'px-5 fw-bold'}
                                    onClick={(e) => handleEliminaProfiloConferma(e)}>
                                Elimina
                            </Button>
                        </Modal.Body>
                    </Modal>

                </Col>
                <Col>
                    <div className={'w-100 mt-4 mt-lg-0 d-flex justify-content-end'}>
                        <LogoutButton/>
                    </div>
                </Col>
            </Row>

            <GenericErrorModal handleClose={handleCloseErrorModal} contentText={errorModal} showModal={errorModal.state}/>

        </>

    );
}

export default Account;
